export default {
  language: 'Language',
  navigation: {
    home: 'Home'
  },
  welcome: {
    title: 'Welcome to Maze Generator',
    generateButton: 'Generate Mazes'
  },
  generate: {
    title: 'Maze Generator',
    difficulty: 'Difficulty',
    difficulties: {
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard'
    },
    themes: {
      label: 'Themes',
      space: 'Space',
      fantasy: 'Fantasy',
      animals: 'Animals'
    },
    regenerateButton: 'Regenerate Mazes',
    downloadButton: 'Download PDF'
  }
}